import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            {t("categories.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("categories.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {categories.map((c) => (
            <a
              key={c.key}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${t(`cat.${c.key}`)} products`}
                  title={`${t(`cat.${c.key}`)} - USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center rounded-full bg-background-50/80 backdrop-blur-sm">
                  <i className={`${c.icon} text-foreground-700 text-sm`}></i>
                </div>
              </div>
              <div className="flex items-center justify-between px-4 py-3">
                <span className="text-sm font-medium text-foreground-900 whitespace-nowrap truncate">
                  {t(`cat.${c.key}`)}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 transition-colors shrink-0"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}